/* ============================================================
   Custom Slideshow Autoplay — Son of Son
   Flickity por defecto pausa autoplay tras interacción del usuario
   (tap, drag, click en dots). Este script fuerza que el autoplay
   continúe SIEMPRE en el slideshow de categorías del home.
   ============================================================ */
(function () {
  'use strict';

  const TARGET_SECTION = 'section_slideshow_categories';

  function findFlickityInstance(el) {
    /* Flickity guarda la instancia en .flickity (de jQuery) o
       en globales internas. Buscamos primero por la propiedad
       data del element. */
    if (window.theme && window.theme.Flickity && window.theme.Flickity.data) {
      return window.theme.Flickity.data(el);
    }
    if (window.Flickity && window.Flickity.data) {
      return window.Flickity.data(el);
    }
    /* Fallback: buscar en propiedades expando del element */
    for (const k of Object.keys(el)) {
      if (k.startsWith('flickity') && el[k] && typeof el[k].player === 'object') {
        return el[k];
      }
    }
    return null;
  }

  function ensureAutoplay(el) {
    const flkty = findFlickityInstance(el);
    if (!flkty || !flkty.player) return false;

    /* Si ya enganchamos los listeners, no repetir */
    if (el.__sfAutoplayBound) return true;
    el.__sfAutoplayBound = true;

    function resume() {
      try {
        if (flkty.player && (flkty.player.state === 'paused' || flkty.player.state === 'stopped')) {
          flkty.player.play();
        }
      } catch (e) {}
    }

    /* Resumir tras CUALQUIER interacción del usuario */
    flkty.on('pointerUp', function () { setTimeout(resume, 50); });
    flkty.on('dragEnd', function () { setTimeout(resume, 50); });
    flkty.on('staticClick', function () { setTimeout(resume, 50); });
    flkty.on('settle', resume);

    /* Adicionalmente: chequear cada 1s que el player está activo.
       Si por alguna razón se pausó (focus blur, etc), reanudar. */
    setInterval(resume, 1500);

    /* Inicio: asegurar que está reproduciendo */
    setTimeout(resume, 100);
    setTimeout(resume, 500);
    setTimeout(resume, 2000);

    return true;
  }

  function init() {
    const sections = document.querySelectorAll('[id*="' + TARGET_SECTION + '"]');
    sections.forEach(function (sec) {
      const slider = sec.querySelector('slideshow-component, [data-slider]');
      if (!slider) return;
      if (!ensureAutoplay(slider)) {
        /* Flickity puede no estar listo aún. Polling corto. */
        let tries = 0;
        const iv = setInterval(function () {
          if (ensureAutoplay(slider) || ++tries > 40) clearInterval(iv);
        }, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-init después de Shopify section render (theme editor) */
  document.addEventListener('shopify:section:load', init);
})();
